<template>
  <div class="about-lime">
    <v-card color="white" width="100%" flat tile>
      <v-container class="py-10">
        <v-row>
          <!-- Privacy Policy -->
          <v-col cols="12">
            <h3 class="heading-h3 mb-2">
              Privacy Policy - Century Financial Services (PTY) LTD
            </h3>
            <h6 class="heading-h6">
              <strong>Century Financial Services (PTY) LTD</strong>
            </h6>
            <h6 class="heading-h6">
              <strong>Company Registration Number: </strong>2023/140135/07
            </h6>
            <h6 class="heading-h6">
              <strong>NCR Registration Number: </strong>NCRCP20790
            </h6>
            <hr class="my-4" />
          </v-col>

          <v-col cols="12" lg="12">
            <!-- 1.	INTRODUCTION -->
            <h4 class="heading-h4 mb-4">1. INTRODUCTION</h4>

            <!-- paragraphsForSection1 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection1"
              :key="'paragraphs-for-section-1-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 2.	THE CUSTOMER’S CONSENT -->
            <h4 class="heading-h4 mb-4">2. THE CUSTOMER CONSENT</h4>

            <!-- paragraphsForSection2 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection2"
              :key="'paragraphs-for-section-2-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 3.	SECURITY AND CONFIDENTIALITY -->
            <h4 class="heading-h4 mb-4">3. SECURITY AND CONFIDENTIALITY</h4>

            <!-- paragraphsForSection3 -->
            <p class="b-body-1">{{ paragraphsForSection3[0].text }}</p>

            <DefaultList
              :listItems="pulletsForSection3"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection3[1].text }}</p>

            <!-- 4.	PERSONAL INFORMATION -->
            <h4 class="heading-h4 mb-4">4. PERSONAL INFORMATION</h4>

            <!-- paragraphsForSection4 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection4"
              :key="'paragraphs-for-section-4-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 5.	COLLECTING THE CUSTOMER’S DATA -->
            <h4 class="heading-h4 mb-4">5. COLLECTION OF PERSONAL DATA</h4>

            <!-- paragraphsForSection5 -->
            <p class="b-body-1">{{ paragraphsForSection5[0].text }}</p>
            <DefaultList
              :listItems="pulletsForSection5"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection5[1].text }}</p>
            <DefaultList
              :listItems="pulletsForSection5Part2"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 6.	COLLECTION AND USE OF PERSONAL INFORMATION -->
            <h4 class="heading-h4 mb-4">
              6. PURPOSES FOR PROCESSING PERSONAL INFORMATION
            </h4>

            <!-- paragraphsForSection6 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection6"
              :key="'paragraphs-for-section-6-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- pulletsForSection6 -->
            <DefaultList
              :listItems="pulletsForSection6"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- paragraphsForSection6Part2 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection6Part2"
              :key="'paragraphs-for-section-6-part-2-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 7.	ADDITIONAL DATA COLLECTION -->
            <h4 class="heading-h4 mb-4">7. COOKIES AND TECHNICAL DATA</h4>

            <!-- paragraphsForSection7 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection7"
              :key="'paragraphs-for-section-7-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 8.	PERSONAL IDENTIFICATION NUMBER -->
            <h4 class="heading-h4 mb-4">8. ACCOUNT SECURITY</h4>

            <!-- paragraphsForSection8 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection8"
              :key="'paragraphs-for-section-8-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 9.	SHARING THE CUSTOMER’S DATA FOR SERVICE PROVISION -->
            <h4 class="heading-h4 mb-4">9. DISCLOSURE TO THIRD PARTIES</h4>

            <!-- paragraphsForSection9 -->
            <p class="b-body-1">{{ paragraphsForSection9[0].text }}</p>

            <!-- pulletsForSection9 -->
            <DefaultList
              :listItems="pulletsForSection9"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection9[1].text }}</p>
            <DefaultList
              :listItems="pulletsForSection9part2"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 10. RIGHT TO REQUEST ACCESS TO THE CUSTOMER’S PERSONAL INFORMATION -->
            <h4 class="heading-h4 mb-4">10. ACCESS TO PERSONAL INFORMATION</h4>

            <!-- paragraphsForSection10 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection10"
              :key="'paragraphs-for-section-10-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>
            <DefaultList
              :listItems="pulletsForSection10"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 11. ELECTRONIC COMMUNICATIONS AND TRANSACTIONS ACT -->
            <h4 class="heading-h4 mb-4">
              11. ELECTRONIC COMMUNICATIONS AND TRANSACTIONS ACT
            </h4>

            <!-- paragraphsForSection11 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection11"
              :key="'paragraphs-for-section-11-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- pulletsForSection11 -->
            <DefaultList
              :listItems="pulletsForSection11"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- paragraphsForSection11Part2 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection11Part2"
              :key="'paragraphs-for-section-11-part-2-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- pulletsForSection11Part2 -->
            <DefaultList
              :listItems="pulletsForSection11Part2"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 12. CONTACT FROM CENTURY FINANCIAL SERVICES AND THIRD PARTIES -->
            <h4 class="heading-h4 mb-4">12. MARKETING COMMUNICATION</h4>

            <!-- paragraphsForSection12 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection12"
              :key="'paragraphs-for-section-12-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 13. THIRD PARTY LINKS -->
            <h4 class="heading-h4 mb-4">13. THIRD PARTY WEBSITES</h4>

            <!-- paragraphsForSection13 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection13"
              :key="'paragraphs-for-section-13-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 14. AGE -->
            <h4 class="heading-h4 mb-4">14. AGE RESTRICTION</h4>

            <!-- paragraphsForSection14 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection14"
              :key="'paragraphs-for-section-14-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 15. CHANGES TO THIS PRIVACY POLICY -->
            <h4 class="heading-h4 mb-4">15. CHANGES TO THIS POLICY</h4>

            <!-- paragraphsForSection15 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection15"
              :key="'paragraphs-for-section-15-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 16. APPLICABLE LAWS -->
            <h4 class="heading-h4 mb-4">16. GOVERNING LAW</h4>

            <!-- paragraphsForSection16 -->
            <p
              v-for="(paragraph, index) in paragraphsForSection16"
              :key="'paragraphs-for-section-16-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import DefaultList from "@/components/shared/lists/DefaultList";

export default {
  name: "LimeLoansPrivacyPolicy",

  components: { DefaultList },

  data() {
    return {
      // paragraphsForSection1
      paragraphsForSection1: [
        {
          text: `This Privacy Policy governs the way Century Financial Services (PTY) LTD (“Century FS”) 
collects, processes, uses, stores, and protects personal information in accordance with South 
African law, including the Protection of Personal Information Act No. 4 of 2013 (“POPIA”). It 
applies to all current and former customers and users (“Customers”) of our services and 
platforms. This Privacy Policy must be read together with the terms and conditions of the Loan 
Agreement and related documentation sent to the Customer during the application process.`,
        },
        {
          text: `Century FS reserves the right to amend or update this Privacy Policy at any time. Updated 
versions will be made available on our website.`,
        },
      ],

      // paragraphsForSection2
      paragraphsForSection2: [
        {
          text: `By submitting personal information and/or using Century FS services, the Customer consents to 
the collection, processing, storage, and sharing of their personal information as described in 
this Policy. Customers may object to certain processing activities, subject to limitations set by 
law. Note that withholding necessary personal information may impact Century FS’s ability to 
process or approve loan application`,
        },
      ],

      // paragraphsForSection3
      paragraphsForSection3: [
        {
          text: `Century FS takes data protection seriously and implements reasonable, industry-standard 
technical and organisational measures to safeguard personal information. These include:`,
        },
        {
          text: `We continuously monitor and update our security infrastructure and remain compliant with the 
Constitution of South Africa, POPIA, the Electronic Communications and Transactions Act (ECT 
Act), the Regulation of Interception of Communications Act, the National Credit Act (NCA), and 
the Consumer Protection Act (CPA).`,
        },
      ],

      // paragraphsForSection4
      paragraphsForSection4: [
        {
          text: `Personal information includes but is not limited to a customer’s name, identity number, contact 
details, financial and credit information, transactional data, and any other data that can 
reasonably be linked to an individual or juristic entity.`,
        },
      ],

      // paragraphsForSection5
      paragraphsForSection5: [
        {
          text: `Century FS collects personal information in two ways:`,
        },
        {
          text: `Collected data may be used for:`,
        },
      ],
      pulletsForSection5: [
        {
          text: `Directly from the Customer via applications, correspondence, and transactions`,
        },
        {
          text: `Indirectly from credit bureaus, service providers, and regulatory sources`,
        },
      ],
      pulletsForSection5Part2: [
        {
          text: `Creditworthiness assessments`,
        },
        {
          text: `Product and risk analysis`,
        },
        {
          text: `Customer support and record-keeping`,
        },
        {
          text: `Fraud and financial crime prevention`,
        },
        {
          text: `Marketing (with consent)`,
        },
        {
          text: `Legal and regulatory compliance`,
        },
      ],

      // paragraphsForSection6
      paragraphsForSection6: [
        {
          text: `We collect and process personal information to:`,
        },
      ],

      pulletsForSection3: [
        {
          text: `Secure Socket Layer (SSL) encryption`,
        },
        {
          text: ` Encrypted storage systems`,
        },
        {
          text: `Firewalls and intrusion detection systems`,
        },
        {
          text: `Restricted, role-based employee access`,
        },
      ],
      // pulletsForSection6
      pulletsForSection6: [
        {
          text: `Verify Customer identity and eligibility`,
        },
        {
          text: `Provide financial services, including personal loans`,
        },
        {
          text: `Comply with legal and contractual obligations`,
        },
        {
          text: `Develop and improve our products and services`,
        },
      ],

      // paragraphsForSection6Part2
      paragraphsForSection6Part2: [
        {
          text: `ustomers may receive promotional materials where prior consent has been granted. Third-party marketing communication will only be facilitated if the Customer has explicitly agreed`,
        },
      ],

      // paragraphsForSection7
      paragraphsForSection7: [
        {
          text: `Century FS uses cookies and similar technologies to enhance user experience, collect usage 
analytics, and remember Customer preferences. Data collected includes IP addresses, device 
types, browser versions, and interaction patterns. This information is anonymised where 
possible and does not identify individuals unless combined with other personal data.`,
        },
        {
          text: `Customers can disable cookies via their browser settings. However, this may impact website 
functionality.`,
        },
      ],

      // paragraphsForSection8
      paragraphsForSection8: [
        {
          text: `Customers are responsible for maintaining the confidentiality of their login credentials, 
including usernames, passwords, and personal identification numbers (PINs). Century FS 
accepts no liability for unauthorised use resulting from negligence in safeguarding access 
details.`,
        },
      ],

      // paragraphsForSection9
      paragraphsForSection9: [
        {
          text: `Personal information may be disclosed to trusted third-party service providers such as:`,
        },
        {
          text: `All such parties are contractually bound to maintain confidentiality and adhere to data 
protection standards. Century FS may also disclose information:`,
        },
      ],

      // pulletsForSection9
      pulletsForSection9: [
        {
          text: `Registered credit bureaus`,
        },
        {
          text: `Payment processors`,
        },
        {
          text: `Regulatory authorities`,
        },
        {
          text: `Debt collection and recovery agencies`,
        },
      ],
      pulletsForSection9part2: [
        {
          text: `To comply with legal obligations or court orders`,
        },
        {
          text: ` During mergers, acquisitions, or asset transfers (with appropriate safeguards)`,
        },
      ],

      // paragraphsForSection10
      paragraphsForSection10: [
        {
          text: `Customers have the right to:`,
        },
      ],

      pulletsForSection10: [
        {
          text: `Request access to personal data (subject to a prescribed fee)`,
        },
        {
          text: `Request correction or deletion of inaccurate, outdated, or unlawfully obtained data`,
        },
        {
          text: `Object to specific forms of processing`,
        },
        {
          text: `Lodge a complaint with the Information Regulator`,
        },
      ],

      // paragraphsForSection11
      paragraphsForSection11: [
        {
          text: `Century FS adheres to Section 51 of the ECT Act by ensuring that personal information is only 
collected, stored, and processed:`,
        },
      ],

      // pulletsForSection11
      pulletsForSection11: [
        {
          text: `With the Customer’s explicit consent (unless legally required)`,
        },
        {
          text: ` For specific, lawful purposes as described in this Policy`,
        },
        {
          text: ` With records kept of the purpose and usage of data`,
        },
      ],

      // paragraphsForSection11Part2
      paragraphsForSection11Part2: [
        {
          text: `Disclosure of personal data may occur without consent:`,
        },
      ],

      // pulletsForSection11Part2
      pulletsForSection11Part2: [
        {
          text: `When legally required`,
        },
        {
          text: `If in the public interest`,
        },
        {
          text: `If in Century FS’s legitimate interest, with implied consent`,
        },
      ],

      // paragraphsForSection12
      paragraphsForSection12: [
        {
          text: `During the loan application process, Customers may opt-in to receive marketing 
communications via SMS, email, or phone. Preferences may be updated via the Customer’s 
online profile at any time. Customers may also register with the national “Opt-Out” register 
managed by the Direct Marketing Association of South Africa (DMASA) at 
                <a href="https://dmasa.org/" 
                class="text-decoration-none font-weight-medium" target="_blank">
                  www.dmasa.org</a>.`,
        },
      ],

      // paragraphsForSection13
      paragraphsForSection13: [
        {
          text: `Our website may contain links to external sites. Century FS accepts no responsibility for the 
privacy practices or content of third-party websites. We advise Customers to review the privacy 
policies of those websites before providing personal information.`,
        },
      ],

      // paragraphsForSection14
      paragraphsForSection14: [
        {
          text: `Century FS does not provide credit services to individuals under the age of 18. Use of our 
website or services by minors is strictly prohibited.`,
        },
      ],

      // paragraphsForSection15
      paragraphsForSection15: [
        {
          text: `Century FS reserves the right to modify this Privacy Policy at any time without prior notice. The 
most current version will always be available on our website. Continued use of our services 
indicates acceptance of any changes`,
        },
      ],

      // paragraphsForSection16
      paragraphsForSection16: [
        {
          text: `This Privacy Policy is governed by the laws of the Republic of South Africa. Any disputes arising 
from this Policy shall be resolved in accordance with the jurisdiction of South African courts or 
by referral to the Credit Ombud.`,
        },
      ],

      listItems1: [
        {
          text: `As one of the world’s leading digital lending internet platforms
                and financial services organisations, our objective is to help
                manage our customer’s financial affairs efficiently, smoothly and
                securely. We believe that maintaining a balanced financial
                position is vital and we see the value in being able to provide
                for our customer’s and their families.`,
        },
        {
          text: `We aim to help connect our customers to opportunities, reinvent
                themselves and help them realize their ambitions with our digital
                lending platform.`,
        },
        {
          text: `Lime is a financial technology company that provides digital
                solutions to change how people borrow money across South Africa.
                We are an entity of our larger holding company Lime Credit Group.
                Utilising advanced algorithms and machine learning capabilities,
                we are able to offer a platform for a customised approach towards
                lending to help unlock the purchasing power of millions, 24/7.`,
        },
        {
          text: `With our world-class team, and the combination of technology,
                analytics and customer service capabilities — we’ve built a
                company uniquely well-appointed to this task to offer a seamless
                process for loans, entirely online.`,
        },
      ],
      listItems2: [
        {
          text: `The Company Intellectual Property Commission – Registration
             Number 2015/239349/07`,
        },
        {
          text: `The National Credit Regulator – Registration Number NCRCP8077 `,
        },
      ],
      listItems3: [
        {
          text: `Address: C505, Bridgewater 3, Century City, Cape Town, 7441`,
        },
        {
          text: `Phone: <a href="tel:+27104426722"
                  class="text-decoration-none font-weight-medium" target="_blank">
                  010 442 6722</a>`,
        },
        {
          text: `Email: <a href="mailto:clientsupport@centuryfinancialservices.net"
                  class="text-decoration-none font-weight-medium" target="_blank"
                >clientsupport@centuryfinancialservices.net</a>`,
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
